<template>
    <div v-if="isMobileScreen" class="setting_list__heading">
        <burger_menu
            :key="'burger_menu'"
        />
    </div>
    <span v-if="!isLoadUserSettings && isMobileScreen"
          class="setting_list__heading_label">{{ __t('O.SYNCHRONIZATION_SETTINGS') }}</span>
    <setting_list
        v-if="!isLoadUserSettings"
        :key="'setting_list'"
    />
</template>

<script>

import menu_orders from "../menu/order/MenuOrders.vue";
import setting_list from "./SettingList.vue";
import {createHelpers} from "vuex-map-fields";
import burger_menu from "../heading/BurgerMenu.vue";
import {screenSize} from "../../mixins/screenSize";
import loader_page from "../loader/LoaderPage.vue";
import {getStateMenu} from "../../helpers/menuState";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})
export default {
    name: "setting_sync_page",
    props: {},
    emits: [],
    components: {
        loader_page,
        burger_menu,
        menu_orders,
        setting_list,
    },
    mixins: [screenSize],
    data() {
        return {
            showOrdersMenu: false,
            isLoadMenu: true,
            isLoadUserSettings: true,
        }
    },
    beforeMount() {
        this.$store.dispatch('user/STATE_LOAD_PAGE', true);
        this.$store.dispatch('user/GET_MENU_MAIN');
        EventBus.$on('load_menu_main', this.loadMenu);
        EventBus.$on('get_user_settings', this.loadUserSettings);
    },
    beforeUnmount() {
        EventBus.$off('load_menu_main', this.loadMenu);
        EventBus.$off('get_user_settings', this.loadUserSettings);
    },
    methods: {
        loadMenu() {
            //EventBus.$emit('get_state_menu_main');

            this.isLoadMenu = false;
            this.changeLoadState();
        },
        loadUserSettings() {
            this.isLoadUserSettings = false;
            this.changeLoadState();
        },
        changeLoadState() {
            if (!this.isLoadMenu && !this.isLoadUserSettings) {
                this.$store.dispatch('user/STATE_LOAD_PAGE', false);
            }
        }
    },
    computed: {
        ...mUser([
            'user',
            'userSettings',
            'isLoadPage'
        ]),
    },
}
</script>
